import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

type UploadOptions = {
  field?: string;
  reportProgress?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FileService {
  resource = 'file'
  constructor(
    @Inject(HttpClient)
    private http: HttpClient
  ) {

  }

  get baseUrl(): string {
    return `${environment.api.baseUrl}/${this.resource}`;
  }

  upload<T>(file: File, option?: UploadOptions): Observable<T> | Observable<HttpEvent<T>> {
    const { field, reportProgress } = { ...option };
    const formData: FormData = new FormData();
    formData.append(field || 'file', file, file.name);
    if (reportProgress) {
      return this.http.post<T>(`${this.baseUrl}/upload`, formData, { reportProgress, observe: 'events' });
    } else {
      return this.http.post<T>(`${this.baseUrl}/upload`, formData);
    }
  }

  delete<T>(id: string): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}/delete/coupon/${id}`, { });
  }

  get<T>(id: string): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${id}`);
  }
}
